import type { DocumentViewModel } from '@trinnvis/dabih-api-client';
import { translateTemplateName } from 'src/i18n/template-content';

export function toDocumentViewModel(item: DocumentViewModel): DocumentViewModel {
  return Object.assign({}, item, { name: translateTemplateName(item.name) });
}
